import axios from 'axios';
import { buildQueryString } from '../utils/searchFilter';

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
const USER_API = axios.create({ baseURL: `${BACKEND_BASE_URL}/api/v1/user` });


// Request interceptor to add authorization and accept headers
USER_API.interceptors.request.use(
  (req) => {
    return req;
  },
  (error) => {
    // console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses and errors
USER_API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with a status other than 2xx
      if (error.response.status === 401) {
        // console.error('Unauthorized access - possibly due to expired token');
      } else {
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "An error occurred";
        if (responseErrors) {
          // console.error('Response errors:', responseErrors);
        } else {
          // console.error('Response error:', fallbackMessage);
        }
      }
    } else if (error.request) {
      // Request was made but no response received
      // console.error('No response received:', error.request);
    } else {
      // Something else caused the error
      // console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export const allowedTransferMethods = (countryCode) => USER_API.get(`/send-money/transfer-options?country=${countryCode}`);
export const getSupportedCountryStates = () => USER_API.get('countries-with-states');

// export const referralLeaderboard = (filters = {}) => USER_API.get(`/leaderboard/referrals?${buildQueryString(filters)}`);
export const referralLeaderboard = (perPage, page, searchQuery) => USER_API.get(`/leaderboard/referrals?per_page=${perPage}&page=${page}&searchQuery=${searchQuery}`);

export default USER_API;